const TERMS_AND_CONDITIONS_PATH = '/documents/legal/modeller-member-website-terms-conditions-2024.pdf';

export default TERMS_AND_CONDITIONS_PATH;
